import { render, staticRenderFns } from "./InventoryDiscounts.vue?vue&type=template&id=89554de4&scoped=true"
import script from "./InventoryDiscounts.vue?vue&type=script&lang=js"
export * from "./InventoryDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89554de4",
  null
  
)

export default component.exports